/*
 * Copyright © 2021 Lexcelon LLC <info@lexcelon.com>
 * Licensed for non-distributable use
 */
import { CircularProgress, Button as MuiButton } from '@mui/material';
import React from 'react';

function Button({
  children,
  isLoading = false,
  disabled,
  secondary = false,
  danger = false,
  outlined = false,
  ...props
}) {
  return (
    <MuiButton
      disabled={isLoading || disabled}
      color={
        danger ? 'error' : !outlined && secondary ? 'secondary' : 'primary'
      }
      variant={danger || outlined ? 'outlined' : 'contained'}
      {...props}
    >
      {children}
      {isLoading && (
        <CircularProgress
          size={18}
          style={{ marginLeft: '10px', color: 'darkgrey' }}
        />
      )}
    </MuiButton>
  );
}

export default Button;